import { Component, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable, Subscription } from 'rxjs';
import { ToastService } from 'src/app/core';
import { AuthService } from 'src/app/core/auth.service';

@Component({
  selector: 'eos-configurable-comment',
  templateUrl: './configurable-comment.component.html',
  styleUrls: ['./configurable-comment.component.css']
})
export class ConfigurableCommentComponent implements OnInit,OnDestroy {

  @Input() comments:any = [];
  @Input() public readonly?: boolean = true;
  @Input() public notEditableCommentType?: number;
  @Input() getComments: () => Observable<any>;
  @Input() updateComment: (comment:any) => Observable<any>;
  @Input() saveComment: (comment:string) => Observable<any>;
  @Input() refreshComments:()=> void;
  employeeId:number;
  DisableSaveUpdate = false;

  commentForm: UntypedFormGroup;
  comment:any;
  editMode = false;

  getCommentSub: Subscription;
  updateCommentSub: Subscription;
  saveCommentSub: Subscription;
  
  constructor(public modal: NgbActiveModal,
  private toast: ToastService,
  private authService:AuthService) {
    this.commentForm = new UntypedFormGroup({
      comment: new UntypedFormControl(null, [Validators.required])
    });
   }

  ngOnInit() {
      this.loadComments();
      this.employeeId = this.authService.ActiveUser.employeeId;
  }

  loadComments(){
    this.getCommentSub = this.getComments().subscribe(resp => {
      this.comments = resp;
    })
  }

  editComment(comm: any) {
    this.comment = comm;
    this.editMode = true;
    this.commentForm.patchValue({
      comment: comm.comment
    });
  }
  update(){
    this.comment.comment = this.commentForm.getRawValue().comment;
    this.updateCommentSub = this.updateComment(this.comment).subscribe(resp => {
            this.commentForm.reset();
            this.toast.success("Successfully updated!");
            this.editMode = false;
            this.loadComments();
        })
  }

  save() {
    if (this.commentForm.value.comment.trim() !== '') {
      this.saveCommentSub = this.saveComment(this.commentForm.value.comment.trim()).subscribe(resp => {
            this.commentForm.reset();
            this.toast.success("Successfully saved!");
            this.editMode = false;
            this.loadComments();
        });;
    }
  }

  ngOnDestroy(){
    if(this.updateCommentSub){
      this.updateCommentSub.unsubscribe();
    }
    if(this.saveCommentSub){
      this.saveCommentSub.unsubscribe();
    }
    if(this.getCommentSub){
      this.getCommentSub.unsubscribe();
    }
  }
}
